import { FunctionComponent } from "react"
import { QueryStatus } from "react-query"
import { css, cx } from "@emotion/css"
import CircularProgress from "@material-ui/core/CircularProgress"

export type FWLoaderPosition = "center" | "top"
export const FieldWithLoader: FunctionComponent<{
  status: QueryStatus
  position?: FWLoaderPosition
  className?: string
}> = ({ children, status, className, position = "center" }) => {
  return (
    <div className={cx(style.fieldWithLoader, className)}>
      {children}
      {status === "loading" && (
        <CircularProgress
          size={30}
          className={cx(style.loader, {
            [style.loaderTop]: position === "top",
            [style.loaderCenter]: position === "center",
          })}
        />
      )}
      {status === "error" && (
        <span className={style.error}>Error loading data!</span>
      )}
    </div>
  )
}

const style = {
  fieldWithLoader: css`
    position: relative;
  `,
  loader: css`
    position: absolute;
  `,
  loaderTop: css`
    left: 0;
    right: 0;
    top: 10%;
    margin: 0 auto;
  `,
  loaderCenter: css`
    inset: 0;
    margin: auto;
  `,
  error: css`
    position: absolute;
    left: 25%;
    top: 15%;
    color: red;
    display: grid;
    grid-auto-flow: column;
    place-items: center;
    padding: 2px 2px 2px 5px;
  `,
}
